export async function simulateNetworkDelay() {
  // We don't need to introduce a delay in real tests. The fact it's an async
  // function delays it to the next tick at least.
  if (typeof jest === 'undefined') {
    // Random integer between 0 and 500
    const delay = Math.floor(Math.random() * 500);
    await new Promise((resolve) => setTimeout(resolve, 100 + delay));
  }
}
